import {
  SettingOutlined,
  HomeOutlined,
  UserOutlined,
  MedicineBoxOutlined,
  CalendarOutlined,
  PieChartOutlined
} from "@ant-design/icons";

/**
 *
 */
export const siips_values = [1, 4, 10, 20];

/**
 *
 */
export const types = [{
  id: 1,
  label: "Urologique",
}, {
  id: 2,
  label: "Vasculaire",
}, {
  id: 3,
  label: "Cardiaque",
}, {
  id: 4,
  label: "Digestive",
}, {
  id: 5,
  label: "Gynécologique",
}, {
  id: 6,
  label: "Maxillo-faciale",
}, {
  id: 7,
  label: "Ophtalmologique",
}, {
  id: 8,
  label: "ORL",
}, {
  id: 9,
  label: "Orthopédique",
}, {
  id: 10,
  label: "Plastique",
}, {
  id: 11,
  label: "Thoracique",
}, {
  id: 11,
  label: "Neurologique",
}];

/**
 *
 */
export const menuItems = [{
  'icon': (<HomeOutlined />),
  'path': '/home',
  'title': 'Accueil',
  'items': [],
  'roleIds': []
}, {
  'icon': (<UserOutlined />),
  'path': '/patient',
  'title': 'Listing Patients',
  'items': [],
  'roleIds': []
}, {
  'icon': (<MedicineBoxOutlined />),
  'path': '/surgical_intervention',
  'title': 'Listing Séjours',
  'items': [],
  'roleIds': []
}, {
  'icon': (<CalendarOutlined />),
  'path': '/calendar',
  'title': 'Visualisation',
  'items': [],
  'roleIds': []
}, {
  'icon': (<PieChartOutlined />),
  'title': 'Reporting',
  'items': [{
    'path': '/daily_occupation_chart',
    'title': "Taux d'occupation journalier",
    'roleIds': []
  }, {
    'path': '/daily_siips_chart',
    'title': "SIIPS journalier",
    'roleIds': []
  }, {
    'path': '/surgical_interventions_stats',
    'title': "Séjours programmés",
    'roleIds': []
  }, {
    'path': '/surgical_interventions_outs_stats',
    'title': "Sorties",
    'roleIds': []
  }, {
    'path': '/daily_intervention_chart',
    'title': "Interventions journalier",
    'roleIds': [1]
  }, {
    'path': '/intervention_by_procedure_stats',
    'title': "Interventions par procedure",
    'roleIds': [1]
  }, {
    'path': '/intervention_by_user_stats',
    'title': "Interventions par chirurgien",
    'roleIds': [1]
  }]
}, {
  'icon': (<SettingOutlined />),
  'title': 'Paramétrage',
  'items': [{
    'path': '/care_units',
    'title': 'Unités',
    'roleIds': [1]
  }, {
    'path': '/users',
    'title': 'Utilisateurs',
    'roleIds': [1]
  }, {
    'path': '/surgical_procedures',
    'title': 'Procédures',
    'roleIds': [1, 4]
  }]
}]

/**
 *
 */
export const cancellationReasons = [
  {
    id: 1,
    label: "double saisie",
  },
  {
    id: 2,
    label: "cause patient",
  },
  {
    id: 3,
    label: "cause organisation",
  },
  {
    id: 4,
    label: "cause maladie",
  },
];

/**
 *
 */
export const reScheduleReasons = [{
  id: 1,
  label: "erreur saisie",
}, {
  id: 2,
  label: "cause patient",
}, {
  id: 3,
  label: "gestion capacitaire",
}, {
  id: 4,
  label: "complication chirurgicale",
}, {
  id: 5,
  label: "complication médicale",
}, {
  id: 6,
  label: "délai établissement convalescence ou HAD",
}, {
  id: 7,
  label: "problème social",
}, {
  id: 8,
  label: "autre",
}];

/**
 *
 */
export const deferredOutputReasons = [
  {
    id: 1,
    label: "complication chirurgicale",
  },
  {
    id: 2,
    label: "complication médicale",
  },
  {
    id: 3,
    label: "délai établissement convalescence ou HAD",
  },
  {
    id: 4,
    label: "problème social",
  },
  {
    id: 5,
    label: "autre",
  },
];
